export enum EmailTemplateType {
    Unspecified = 0,
    Classic = 1,
    Minimal = 2,
    Header = 3
}